export default __webpack_public_path__ + "static/media/plethori.23b862ac.svg";